export default __webpack_public_path__ + "static/media/PropertyCo.334623cb.svg";